module.exports = __webpack_public_path__ + "img/logo_clpga.f564eabd.png";